<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    {{ message }}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="decline()">
      {{ btnCancelText }}
    </button>
    <button type="button" class="btn btn-success" (click)="accept()">
      {{ btnOkText }}
    </button>
  </div>
</div>
